import { readUnhandledEnumCase } from 'rpc-client-utils';
import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
export const hasPurchaseRequest = ctaProps => {
  return ctaProps !== undefined && 'purchaseRequest' in ctaProps && ctaProps.purchaseRequest !== undefined && !('currencyCode' in ctaProps && ctaProps.currencyCode !== undefined);
};
export const hasCurrencyCode = ctaProps => {
  return ctaProps !== undefined && 'currencyCode' in ctaProps && ctaProps.currencyCode !== undefined && !('purchaseRequest' in ctaProps && ctaProps.purchaseRequest !== undefined);
};
export const isApiName = apiName => Object.hasOwn(ApiNameToUpgradeProductMap, apiName);
export const isValidTalkToSalesPurchaseMotion = purchaseMotion => ['BLOCKED', 'TALK_TO_SALES', 'TALK_TO_SALES_FALLBACK'].includes(readUnhandledEnumCase(purchaseMotion));